module.exports = __webpack_public_path__ + "static/media/SF-4-A.ccb4157f.mp3";